import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Protected from '@ui/components/protected/Protected';
import UserAvatar from '@ui/components/user-avatar/UserAvatar';
import simpleLocation from '@ui/utils/simpleLocation';
import slugOrID from '@ui/utils/slugOrID';
import userFullName from '@ui/utils/userFullName';
import Link from 'next/link';
import React, { CSSProperties } from 'react';

import useStyles from './UserCard.style';

interface UserCardProps {
  user?: Partial<guesthouse.User>;
  showRating?: boolean;
  showLocation?: boolean;
  showNumItems?: boolean;
  numItems?: number;
  style?: CSSProperties;
  className?: string;
  onClick?: (user: Partial<guesthouse.User>) => void;
}

const UserCard: React.FC<UserCardProps> = (props) => {
  const { user, style, className, onClick, showRating, showLocation } = props;
  const { classes } = useStyles();

  const styleObj: CSSProperties = { ...style };

  if (typeof props.onClick === 'function') {
    styleObj.cursor = 'pointer';
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      className={className}
      style={styleObj}
      onClick={() => typeof onClick === 'function' && onClick(user)}
    >
      <Link
        href={`/shop/makers/${slugOrID(user)}`}
        style={{ display: 'block', width: '100%' }}
      >

        <UserAvatar
          user={user}
          size="100%"
        />

      </Link>

      <Link
        href={`/shop/makers/${slugOrID(user)}`}
        style={{ textDecoration: 'none' }}
      >

        <Typography
          variant="h5Alt"
          className={classes.userCardName}
          align="center"
        >
          {userFullName(user, true)}
        </Typography>

      </Link>

      {showRating && (
        <Protected allowedRoles={['admin', 'designer', 'design_manager', 'website_manager', 'customer_support']}>
          <Rating
            readOnly
            size="small"
            value={user.rating}
            precision={.5}
          />
        </Protected>
      )}

      {showLocation && user.location && (
        <Typography
          variant="caption1"
          align="center"
          style={{ display: 'block' }}
        >
          {simpleLocation(user.location)}
        </Typography>
      )}
    </Box>
  );
};

UserCard.defaultProps = {
  onClick: null,
  user: {},
  style: {},
  className: null,
};

export default UserCard;
